<template>
  <h3
    class="title2-container"
    :class="[content.titleImage ? 'title2-image-container' : '', device.isMobile ? 'title2-container-mobile' : '']"
    :id="content.key"
    :style="{
      fontFamily: content.textStyle.fontFamily || '',
      fontSize: (content.textStyle.fontSize + 'rem') || '',
      lineHeight: (content.textStyle.lineHeight + 'rem') || '',
      textIndent: (typeof content.textStyle.textIndent === 'string') ? content.textStyle.textIndent :
        (typeof content.textStyle.textIndent === 'number') ? (content.textStyle.textIndent + 'rem') : '',
      fontWeight: content.textStyle.fontWeight || '',
      textDecoration: content.textStyle.underline === 1 ? 'underline' : '',
      fontStyle: content.textStyle.fontItalic === 1 ? 'italic' : '',
      textAlign: content.textStyle.textAlign || '',
      color: content.textStyle.color || '',
      backgroundColor: content.textStyle.backgroundColor || '',
      backgroundImage: content.textStyle.backgroundImage ? `url(${content.textStyle.backgroundImage})` : '',
      marginTop: (content.textStyle.marginTop + 'rem') || '',
      marginBottom: (content.textStyle.marginBottom + 'rem') || '',
    }"
  >
    <img class="title-image" v-if="content.titleImage" :src="content.titleImage" alt="">
    <span class="title-text" :id="`${content.key}-1`">
      <span
        :id="`${content.key}-1-1`"
        :style="{
          fontSize: content.shortTextSize ? content.shortTextSize + 'rem' : '',
        }"
        v-html="content.shortText"
      ></span>
      <span
        :id="`${content.key}-1-2`"
        :style="{
          fontSize: content.textSize ? content.textSize + 'rem' : '',
        }"
        v-html="content.text"
      ></span>
    </span>
  </h3>
</template>
<script>
/*
标题-2
*/
export default {
  name: "title-2",
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title2-container{
  margin-bottom: 30rem;
  width: 100%;
  height: 148rem;
  background: url(~@/assets/images/books/bookExample/section_title_bg_2.png) center center no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28rem;
  color: #fff;
  line-height: 40rem;

  .title-text{
    width: 682rem;
    padding-left: 30rem;
    position: relative;

    &:before{
      content: '';
      width: 3rem;
      height: 75rem;
      background: #fff;
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
    }
    
    span{
      display: block;
    }
  }
}
.title2-image-container{
  height: auto;
  position: relative;
  .title-image{
    width: 100%;
    height: auto;
  }
  .title-text{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.title2-container-mobile{
  margin-bottom: 40rem;
  font-size: 32rem;
  // line-height: 50rem;
}
</style>